import { render } from "./url.vue?vue&type=template&id=50bf0871&ts=true"
import script from "./url.vue?vue&type=script&lang=ts"
export * from "./url.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__